import React, { useCallback, useRef, useState } from 'react';
import { Button, Row, Col } from 'reactstrap';
import _ from 'lodash';

import {
  Intl, LocalTable, ModalInfo, TextField,
} from 'components';

export default ( {
  values, open, onConfirmContacts, onClose,
} ) => {
  const contacts = useRef( values.contacts || [] );
  const [unselectedContacts, setUnselectedContacts] = useState( _.map( _.filter( values.contacts || [], { selected: false } ), 'id' ) );

  const toggleSelected = useCallback( ( row ) => {
    if ( row.original.id ) {
      const newContacts = _.cloneDeep( unselectedContacts );
      const contactIndex = _.indexOf( newContacts, row.original.id );
      if ( contactIndex === -1 ) {
        newContacts.push( row.original.id );
      } else {
        newContacts.splice( contactIndex, 1 );
      }
      setUnselectedContacts( newContacts );
    }
  }, [unselectedContacts] );

  return (
    <ModalInfo
      title="searchPhones"
      size="lg"
      bodyClassName="add-contact-phone-modal"
      open={open}
      onClose={onClose}
      bodyStyle={{ minHeight: 250 }}
      footer={(
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
          type="button"
          onClick={() => {
            onConfirmContacts( _.map( contacts.current, ( item ) => ( {
              ...item,
              selected: unselectedContacts.indexOf( item.id ) === -1,
            } ) ) );
          }}
        >
          <Intl id="okBtn" />
        </Button>
      )}
    >
      <Row className="my-3">
        <Col md={7} className="m-auto campaign-wizard-table">
          <LocalTable
            data={contacts.current.length < 5
              ? contacts.current.concat( new Array( 5 - contacts.current.length )
                .fill( { empty: true } ) )
              : contacts.current}
            manualPagination
            onlyTable
            customFilters={( { filters, setFilter } ) => (
              <Row>
                <Col md={4} className="pr-md-0">
                  <TextField
                    name="nameId"
                    formGroupClass="m-0"
                    value={filters.nameId}
                    onChange={( value ) => {
                      setFilter( 'nameId', value );
                    }}
                  />
                </Col>
                <Col md={7} className="mt-2 mt-md-0">
                  <TextField
                    name="phoneNumber"
                    formGroupClass="m-0"
                    value={filters.phoneNumber}
                    onChange={( value ) => {
                      setFilter( 'phoneNumber', value );
                    }}
                  />
                </Col>
              </Row>
            )}
            getRowProps={( row ) => ( {
              onClick: () => toggleSelected( row ),
              className: row.original.id && unselectedContacts.indexOf( row.original.id ) === -1 ? 'bg-orange-6' : '',
            } )}
            columns={[
              {
                Header: 'nameOrId',
                accessor: 'nameId',
                customWidth: 116,
              },
              {
                Header: <Intl
                  id="phonesDuplicatedCount"
                  values={{
                    total: contacts.current.length,
                  }}
                />,
                disableTranslate: true,
                accessor: 'phoneNumber',
                customWidth: 283,
              },
            ]}
          />
        </Col>
      </Row>
    </ModalInfo>
  );
};
